@if (contato) {
  <div class="modal-chat">
    <app-chat-conversa
      [contato]="contato"
      [mostrarVoltar]="true"
      (voltar)="onVoltar()"
      (atendimentoEncerrado)="aoEncerrarAtendimento()"
      (atendimentoTransferido)="aoEncerrarAtendimento()"
    ></app-chat-conversa>
  </div>
}
